import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { TemplateDialogComponent } from './template-dialog.component'
import { Template, TemplateType } from '@tokeet-frontend/templates'

@Injectable()
export class TemplateDialogService {
  constructor(private dialog: DialogService) {}

  open(data?: { type?: TemplateType; template?: Template; hideType?: boolean; hideTemplates?: boolean }) {
    const defaultConfig: MatDialogConfig = {
      data: { ...data },
    }

    return this.dialog.openDrawer(TemplateDialogComponent, defaultConfig)
  }
}
